import { combineReducers } from "redux";
import profile from "./profile";
import setting from "./setting";
import runtime from "./runtime";
import site from "./site";
import websocket from "./websocket";

export default combineReducers({
  websocket,
  profile,
  setting,
  runtime,
  site,
});
